<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">K-12 and E-Learning</h1>
                        <h2>為學生提供寫作輔助　讓教師評量更輕鬆</h2>
                        <p>
                            Trinka 的先進 AI 智慧不僅協助學生提升寫作能力，更能在寫作過程中學習最佳學術寫作技巧。教師則可透過自動評估與寫作洞察，提供更具針對性的回饋。
                        </p>
                        <div class="btn-group">
                            <button (click)="navigationService.goToEnterpriseForm()" class="filled-btn nowrap" type="button">索取報價 </button>
                            <a href="https://calendly.com/trinkaai/meet" target="_blank" id="autoEditGetStart" class="outline-btn">預約產品演示</a>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <img src="/assets/images/enterprise/K12-and-elearning.webp" width="500" height="500" alt="K-12 and E-Learning" class="img-fluid md50" priority />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd trinka-key-features">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title mb-0 text-center">
                    <h2>專為教育領域設計的解決方案</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="gt-features">
                    <span class="hr-line d-sm-none"></span>
                    <span class="vr-line l25 d-sm-block d-none"></span>
                    <span class="vr-line l50"></span>
                    <span class="vr-line l75 d-sm-block d-none"></span>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>學校/K-12</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>大專院校</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>英語語言學習APP</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>數位學習平台</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd-sm bg-light">
    <app-trusted-global-leaders [sliderData]="globalSliderData"></app-trusted-global-leaders>
</section>

<section class="section-pd docuMarkForUniversities">
    <app-documark-for-universities></app-documark-for-universities>
</section>

<section class="section-pd list-wrapper-style-2 bg-light-purple">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>高品質寫作協助　讓學生與教師都受益</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinka 不只幫助學生寫出更清晰的內容，也提供教師有助教學的深入分析報告。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-none">
                    <div class="features_cards_icon">
                        <img src="/assets/images/Real-timewritingsuggestions.png" width="40" height="40" alt="suggestion-corrections" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>實時寫作建議</h3>
                        <p>Trinka 專為學術英文設計，不僅修正文法錯誤，更協助學生優化詞彙、語氣、句構等表達方式，並從修正建議中學習。</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title">
                    <div class="features_cards_icon">
                        <img src="/assets/images/Automatedfilecorrections.png" width="40" height="40" alt="automated file" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>自動修正文稿與錯誤報告</h3>
                        <p>只需上傳 Word 文件，Trinka 即會提供含「修訂標記」的編輯檔，以及完整錯誤報告，大幅簡化教師的評閱流程。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/Qualityassessment.png" width="40" height="40" alt="quality assessments" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>可自訂寫作評分</h3>
                        <p>透過可調整的評分演算法，學生可即時查看寫作品質分數與詳細說明，有助於理解錯誤並持續進步。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/ComprehensiveAnalytics.svg" width="40" height="40" alt="comprehensive analytics" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>完整數據分析</h3>
                        <p>可檢視整體學習成效，或針對個別學生進行深入追蹤與診斷，提升教學成效。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/ppc_icon.png" width="40" height="40" alt="ppc" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>抄襲檢查</h3>
                        <p>整合全球最大學術資料庫，提供高準確度的原創性檢測。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/FileLevelRestrictions.svg" width="40" height="40" alt="file level" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>檔案層級權限控管</h3>
                        <p>細緻的存取控制，讓學校能輕鬆管理校內與遠距學生的使用權限。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/EasyUserManagement.svg" width="40" height="40" alt="easy use" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>簡易管理，靈活高效</h3>
                        <p>使用團隊帳號，您可以在幾秒內管理存取權限、交換授權，或新增成員，其他設定將自動完成，輕鬆又省時。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/DedicatedSupport.svg" width="40" height="40" alt="dedicated support" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>專屬支援服務</h3>
                        <p>專屬客戶經理將協助您的團隊充分發揮 Trinka 的效益，服務內容包括詳細的入門說明電話、協助文件以及操作影片導覽。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="">
    <app-iplisting></app-iplisting>
</section>

<section class="list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row">
            <div class="col-12">
                <div class="section-usecases section-purple rounded-sm">
                    <div class="row justify-content-center">
                        <div class="col-md-12 col-lg-12">
                            <div class="trinka-title mb-0 text-center">
                                <h2>Trinka 企業版 — 專為 K-12 與線上學習平台打造</h2>
                                <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                                <p>探索 Trinka 專為教育平台量身設計的功能，全面提升教學與學習品質：</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-none">
                                <h3>追蹤學習進展</h3>
                                <p>透過詳細的分析報告，清楚掌握學生寫作能力的成長軌跡：</p>
                                <ul>
                                    <li>寫作品質分數</li>
                                    <li>錯誤類型分類報告</li>
                                    <li>每項錯誤均提供修正建議與學習引導</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards">
                                <h3>找出學習落差</h3>
                                <p>根據錯誤類型與頻率統計，協助教師辨識每位學生的個別學習需求：</p>
                                <ul>
                                    <li>可自訂的自動評分機制</li>
                                    <li>錯誤摘要分析</li>
                                    <li>可追蹤的修正文稿與教師回饋</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-1">
                                <h3>即時學習輔助</h3>
                                <p>Trinka AI 能即時分析學生文本內容，提出具體修改建議，並說明錯誤原因，協助學生在寫作中即時學習與改進</p>
                                <ul>
                                    <li>語境相關建議</li>
                                    <li>詳盡錯誤說明</li>
                                    <li>動態互動式評分機制</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-grammar-without-internet [windowsButton]="false"></app-grammar-without-internet>

<section class="section-pd list-wrapper-style-2 tailoredSolutions">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>您的學術寫作助理，隨時隨地陪伴</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>為您的學生、教職員與研究人員提供便捷的寫作輔助工具，輕鬆整合於日常工作平台，提升效率與生產力。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <h3>
                        雲端編輯器
                    </h3>
                    <p>
                        隨時隨地使用 Trinka 的完整功能，安全的網頁應用助您輕鬆寫作。
                    </p>
                    <a [routerLink]="['/trinkacloud']" class="text-link d-flex align-items-center mb-0">
                        了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"><path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g>
                        </svg>
                    </a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>
                        MS Word Add-in
                    </h3>
                    <p>
                        透過 MS Word 內建的寫作建議，提升團隊的工作效率。
                    </p>
                    <a [routerLink]="['/wordplugin']" class="text-link d-flex align-items-center mb-0">
                        了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"><path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g>
                        </svg>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>
                        瀏覽器擴充功能
                    </h3>
                    <p>
                        支援您常用瀏覽器的即時寫作協助，隨時隨地提升文字品質。
                    </p>
                    <a [routerLink]="['/browser-plugin']" class="text-link d-flex align-items-center mb-0">
                        了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"><path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<app-local-invoice></app-local-invoice>

<app-about-trinka></app-about-trinka>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-10">
                <div class="trinka-title text-center">
                    <h3 class="text-white">讓學生藉由 Trinka 寫作更出色</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <button (click)="navigationService.goToEnterpriseForm()" class="white-btn nowrap" type="button">立即索取報價</button>
                </div>
            </div>
        </div>
    </div>
</section>